export default [
  {
    path: "/pcp",
    name: "pcp",
    label: "PCP",
    component: () => import("@/components/home/MenuPCP.vue"),
  },
  {
    path: "/pcp/mrp",
    name: "pcp.mrp",
    label: "MRP",
    component: () => import("@/components/home/MenuMRP.vue"),
  },
  {
    path: "/pcp/cadastros",
    name: "pcp.cadastros",
    label: "Cadastros",
    component: () => import("@/components/pcp/cadastros/home-cadastros.vue"),
  },
  {
    path: "/pcp/mrp/gerenciar",
    name: "pcp.mrp.gerenciar",
    label: "Gerenciar MRP",
    component: () => import("@/components/pcp/mrp/gerenciar-mrp.vue"),
  },
  {
    path: "/pcp/mrp/gerenciar-mrp/show/:id",
    name: "pcp.mrp.visualizar",
    label: "Visualizar MRP",
    component: () => import("@/components/pcp/mrp/gerenciar-mrp-show.vue"),
  },
  {
    path: "/pcp/formulacoes",
    name: "pcp.formulacoes",
    label: "Formulacões",
    component: () => import("@/components/pcp/formulacoes/home-formulacoes.vue"),
  },
  {
    path: "/pcp/producao",
    name: "pcp.producao",
    label: "Produção",
    component: () => import("@/components/pcp/producao/home-producao.vue"),
  },
  {
    path: "/pcp/producao/cadastro-producao",
    name: "pcp.cadastros.turnos.novo",
    label: "Cadastrar Turnos de Produção",
    component: () => import("@/components/pcp/producao/cadastro-producao/cadastro-producao.vue"),
  },
  {
    path: "/pcp/estoque/historico/:codmatpri",
    name: "pcp.cadastros.materia-prima.historico",
    label: "Visualizar Histórico Detalhado de Insumos",
    component: () => import("@/components/pcp/cadastros/materia-prima/historico-estoque.vue"),
  },
  {
    path: "/pcp/relatorios",
    name: "pcp.relatorios",
    label: "Relatórios",
    component: () => import("@/components/pcp/relatorios/home-relatorios.vue"),
  },
  {
    path: "/pcp/mrp/planejamento",
    name: "pcp.mrp.planejamento",
    label: "Gerenciar Planejamento de Produção",
    component: () => import("@/components/pcp/relatorios/planejamento-producao.vue"),
  },
  {
    path: "/pcp/producao/gerenciar-cadastro-producao",
    name: "pcp.cadastros.turnos",
    label: "Gerenciar Turnos de Produção",
    component: () => import("@/components/pcp/producao/cadastro-producao/gerenciar-cadastro-producao.vue"),
  },
  {
    path: "/pcp/producao/cadastro-hora-produzida/:id",
    name: "pcp.producao.hora-produzida-cadastrar",
    label: "Cadastrar Hora Produzida",
    component: () => import("@/components/pcp/producao/cadastro-producao/cadastro-hora-produzida.vue"),
  },

  {
    path: "/pcp/producao/dashboard-producao",
    name: "pcp.producao.dashboard-producao",
    label: "Dashboard OEE",
    component: () => import("@/components/pcp/producao/cadastro-producao/dashboard-producao.vue"),
  },

  {
    path: "/pcp/producao/gerenciar-motivo-parada",
    name: "pcp.producao.gerenciar-motivo-parada",
    label: "Gerenciar Motivo de Parada",
    component: () => import("@/components/pcp/producao/cadastro-producao/gerenciar-motivo-parada.vue"),
  },

  {
    path: "/pcp/cadastros/cadastro-tempo-total-disponivel",
    name: "pcp.cadastros.cadastro-tempo-total-disponivel",
    label: "Visualizar Lista de Tempo Total Disponível",
    component: () => import("@/components/pcp/producao/cadastro-producao/cadastro-tempo-total-disponivel.vue"),
  },
  {
    path: "/pcp/cadastros/unidade-medida/editar/:id",
    name: "estoque.cadastros.insumos.unidade-medida.editar",
    label: "Editar Unidades de Medida",
    component: () => import("@/components/pcp/cadastros/unidade-medida/cadastro-unidade-medida.vue"),
  },
  {
    path: "/pcp/producao/analise-paradas",
    name: "pcp.producao.analise-paradas",
    label: "Visualizar Análise Detalhada de Paradas",
    component: () => import("@/components/pcp/producao/cadastro-producao/analise-paradas.vue"),
  },

  {
    path: "/pcp/cadastros/gerenciar-linhas-producao",
    name: "pcp.cadastros.gerenciar-linhas-producao",
    label: "Gerenciar Linhas de Produção",
    component: () => import("@/components/pcp/producao/cadastro-producao/gerenciar-linhas-producao.vue"),
  },
  {
    path: "/pcp/cadastros/turnos",
    name: "pcp.cadastros.turnos-linha",
    label: "Gerenciar Turnos",
    component: () => import("@/components/pcp/producao/cadastro-producao/gerenciar-turnos-linha.vue"),
  },
  {
    path: "/pcp/configuracoes/custos-indiretos",
    name: "pcp.configuracoes.custos-indiretos",
    label: "Visualizar Lista de Custos Indiretos",
    component: () => import("@/components/pcp/cadastros/custos-indiretos/custos-indiretos.vue"),
  },
  {
    path: "/pcp/configuracoes/total-pago",
    name: "pcp.configuracoes.total-pago",
    label: "Visualizar Total Pago",
    component: () => import("@/components/pcp/cadastros/custos-indiretos/total-pago.vue"),
  },
  {
    path: "/pcp/producao/ordem-producao/gerenciar/produto-acabado/emitir",
    name: "pcp.producao.produto-acabado-novo",
    label: "Criar Ordem de Produção - Produto Acabado",
    component: () => import("@/components/pcp/producao/nova-ordem-producao.vue"),
  },
  {
    path: "/pcp/producao/ordem-producao/gerenciar/editar/:id",
    name: "pcp.producao.gerenciar.editar",
    label: "Editar Ordem de Produção",
    component: () => import("@/components/pcp/producao/nova-ordem-producao.vue"),
  },
  {
    path: "/pcp/producao/ordem-producao/gerenciar/produto-processo/emitir",
    name: "pcp.producao.produto-processo-novo",
    label: "Criar Ordem de Produção - Produto em Processo",
    component: () => import("@/components/pcp/producao/nova-ordem-producao-pp.vue"),
  },
  {
    path: "/pcp/producao/planejamento-reposicao",
    name: "pcp.producao.planejamento-reposicao",
    label: "Planejamento de Reposição",
    component: () => import("@/components/pcp/producao/planejamento-reposicao.vue"),
  },
  {
    path: "/pcp/producao/planejamento-estoque-comprometido",
    name: "pcp.producao.planejamento-estoque-comprometido",
    label: "Planejamento de Estoque Comprometido",
    component: () => import("@/components/pcp/producao/planejamento-estoque-comprometido.vue"),
  },
  {
    path: "/pcp/producao/gerenciar",
    name: "pcp.producao.gerenciar",
    label: "Visualizar Lista de Ordens de Produção",
    component: () => import("@/components/pcp/producao/gerenciar-ordem-producao.vue"),
  },
  {
    path: "/pcp/producao/gerenciamento-por-etapas",
    name: "pcp.producao.gerenciamento-por-etapas",
    label: "Gerenciamento por Etapas",
    component: () => import("@/components/pcp/producao/gerenciamento-por-etapas.vue"),
  },
  {
    path: "/pcp/producao/gerenciar/separar-insumos/:id",
    name: "pcp.producao.gerenciar.separar-insumos",
    label: "Separar Insumos",
    component: () => import("@/components/pcp/producao/separar-insumos.vue"),
  },
  {
    path: "/pcp/producao/ordem-producao/gerenciar-show/editar/:id",
    name: "pcp.producao.ordem-producao.gerenciar-show.edit",
    label: "Visualizar Ordem de Produção",
    component: () => import("@/components/pcp/producao/gerenciar-ordem-producao-show.vue"),
  },
  {
    path: "/pcp/producao/tags",
    name: "pcp.tags",
    label: "Tags de Produção",
    component: () => import("@/components/pcp/producao/PcpTags.vue"),
  },
  {
    path: "/pcp/producao/tipos-tarefa",
    name: "pcp.tipos-tarefa",
    label: "Tipos de Tarefa de Produção",
    component: () => import("@/components/pcp/producao/PcpConfiguracaoTiposTarefa.vue"),
  },
  {
    path: "/pcp/producao/grupo-op/:id",
    name: "pcp.producao.grupo-op.show",
    label: "Visualizar Grupo de Ordens de Produção",
    component: () => import("@/components/pcp/producao/grupo-op-show.vue"),
  },
  {
    path: "/pcp/producao/grupo-op/:id/separar-insumos",
    name: "pcp.producao.grupo-op.separar-insumos",
    label: "Separar Insumos do Grupo",
    component: () => import("@/components/pcp/producao/grupo-op-separar-insumos.vue"),
  },
  {
    path: "/pcp/formulacoes/produto-acabado",
    name: "pcp.formulacoes.produtos",
    label: "Visualizar Lista de Produtos Acabados",
    component: () => import("@/components/pcp/formulacoes/formulacoes-produtos.vue"),
  },
  {
    path: "/pcp/formulacoes/produto-processo",
    name: "pcp.formulacoes.materia-prima",
    label: "Visualizar Lista de Produtos em Processo e Insumos",
    component: () => import("@/components/pcp/formulacoes/formulacoes-materia-prima.vue"),
  },
  {
    path: "/pcp/relatorios/custos-totais-estoque",
    name: "pcp.relatorios.custos-totais-estoque",
    label: "Relatório de Custos Totais",
    component: () => import("@/components/pcp/relatorios/materia-prima-custo.vue"),
  },
  {
    path: "/pcp/relatorios/consumo-materia-prima-producao",
    name: "pcp.relatorios.consumo-producao",
    label: "Relatório de Consumo de Produção",
    component: () => import("@/components/pcp/relatorios/consumo-producao.vue"),
  },
  {
    path: "/pcp/relatorios/previsao-producao",
    name: "pcp.relatorios.previsao-producao",
    label: "Relatório de Previsão de Produção",
    component: () => import("@/components/pcp/relatorios/previsao-producao.vue"),
  },
  {
    path: "/pcp/formulacoes/produto-show/:id",
    name: "pcp.formulacoes.visualizar",
    label: "Visualizar Formulações de Produtos",
    component: () => import("@/components/estoque/cadastros/produto/form-produto.vue"),
  },
  {
    path: "/pcp/relatorios/pcp/custo",
    name: "pcp.relatorios.pcp.custo",
    redirect: { name: "pcp.relatorios.custos-totais-estoque" },
  },
  {
    path: "/pcp/relatorios/historico-estoque-materia-prima",
    name: "pcp.relatorios.historico-estoque-materia-prima",
    label: "Relatório de Histórico de Estoque de Insumos",
    component: () => import("@/components/pcp/relatorios/historico-estoque-materia-prima.vue"),
  },
  {
    path: "/pcp/relatorios/perdas-producao",
    name: "pcp.relatorios.perdas-producao",
    label: "Relatório de Perdas de Produção",
    component: () => import("@/components/pcp/relatorios/perdas-producao.vue"),
  },
  {
    path: "/pcp/relatorios/etapas-producao",
    name: "pcp.relatorios.etapas-producao",
    label: "Relatório de Etapas de Produção",
    component: () => import("@/components/pcp/relatorios/etapas-producao.vue"),
  },
  {
    path: "/pcp/relatorios/planejado-vs-realizado",
    name: "pcp.relatorios.planejado-vs-realizado",
    label: "Relatório de Planejado vs Realizado",
    component: () => import("@/components/pcp/relatorios/planejado-vs-realizado.vue"),
  },
  {
    path: "/pcp/relatorios/custo-producao",
    name: "pcp.relatorios.custo-producao",
    label: "Relatório de Custo de Produção",
    component: () => import("@/components/pcp/relatorios/custo-producao.vue"),
  },
  {
    path: "/pcp/relatorios/linhas-producao",
    name: "pcp.relatorios.linhas-producao",
    label: "Relatório de Linhas de Produção",
    component: () => import("@/components/pcp/relatorios/linhas-producao.vue"),
  },
  {
    path: "/pcp/mrp/demandas",
    name: "pcp.mrp.demandas",
    label: "Visualizar Lista de Demandas do MRP",
    component: () => import("@/components/pcp/mrp/DemandasMRP.vue"),
  },
  {
    path: "/pcp/mrp/demandas/novo",
    name: "pcp.mrp.demandas.novo",
    label: "Criar Nova Demanda do MRP",
    component: () => import("@/components/pcp/mrp/NovaDemandaMRP.vue"),
  },
  {
    path: "/pcp/mrp/gerenciar/novo",
    name: "pcp.mrp.novo",
    label: "Criar Novo MRP",
    component: () => import("@/components/pcp/mrp/NovoMRP.vue"),
  },
  {
    path: "/pcp/cadastros/etapas",
    name: "pcp.cadastros.etapas",
    label: "Visualizar Lista de Etapas",
    component: () => import("@/components/pcp/producao/etapas/gerenciar-etapas.vue"),
  },
  {
    path: "/pcp/cadastros/perdas",
    name: "pcp.cadastros.perdas",
    label: "Visualizar Lista de Motivos de Perda",
    component: () => import("@/components/pcp/cadastros/perdas/gerenciar-perdas.vue"),
  },

  {
    path: "/pcp/cadastros/maquinarios",
    name: "pcp.cadastros.maquinarios",
    label: "Visualizar Lista de Maquinários",
    component: () => import("@/components/pcp/producao/etapas/cadastro-maquinarios.vue"),
  },
  {
    path: "/pcp/configuracoes",
    name: "pcp.configuracoes",
    label: "Configurações",
    component: () => import("@/components/pcp/configuracoes/home-configuracoes.vue"),
  },
  {
    path: "/pcp/metas-comissionamento",
    name: "pcp.indicadores.metas-comissionamento",
    label: "Metas e Comissionamento de PCP",
    component: () => import("@/components/pcp/indicadores/MetasComissionamentoPcp.vue"),
  },
  {
    path: "/pcp/indicadores",
    name: "pcp.indicadores",
    label: "Indicadores de PCP",
    component: () => import("@/components/pcp/indicadores/IndicadoresPcp.vue"),
  },
];
